import { Link, useLocation } from 'react-router-dom';

const breadcrumbNameMap: Record<string, string> = {
  '': '首页',
  'category': '分类',
  'dianshiju': '电视剧',
  'dianying': '电影',
  'zongyi': '综艺',
  'dongman': '动漫',
  'jilupian': '纪录片',
  'article': '详情',
  'about': '关于我们',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  if (pathSegments.length === 0) return null;

  const breadcrumbs = pathSegments.map((segment, index) => {
    const url = `/${pathSegments.slice(0, index + 1).join('/')}`;
    const name = breadcrumbNameMap[segment] || segment;
    return { url, name, isLast: index === pathSegments.length - 1 };
  });

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <div className="max-w-[1280px] mx-auto">
        <ol className="flex items-center gap-2 text-sm flex-wrap">
          <li>
            <Link to="/" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
              <i className="ri-home-4-line"></i>
              <span className="sr-only">首页</span>
            </Link>
          </li>
          {breadcrumbs.map((crumb) => (
            <li key={crumb.url} className="flex items-center gap-2">
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              {crumb.isLast ? (
                <span className="text-foreground-800 font-medium">{crumb.name}</span>
              ) : (
                <Link to={crumb.url} className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  {crumb.name}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}